export default __webpack_public_path__ + "static/media/integrations.0a559ddb.svg";